import React from 'react';
import PrivacyPolicy from '../PrivacyPolicy';
import { render } from '../../../newRender';

describe('PrivacyPolicy', () => {
  it('should be defined', () => {
    expect(PrivacyPolicy).toBeDefined();
  });

  it('should render', () => {
    const mockLocation = {
      query: {
        type: 'entity1 entity2',
      },
    };

    const wrapper = render(<PrivacyPolicy location={mockLocation} />);
    expect(wrapper).toBeDefined();
  });
});
